export default "__VITE_ASSET__C4c4U_86__"